<template>
	<section class="min-h-screen py-8 px-4 sm:px-8">
		<div class="mx-auto grid w-full max-w-6xl grid-cols-1 overflow-hidden rounded-3xl border border-slate-200 shadow-xl xl:grid-cols-2">
			<div class="hidden xl:flex flex-col justify-between p-12 border-r border-slate-200 bg-gradient-to-br from-[#E7A329] via-[#D68D0A] to-[#CD7D00]">
				<div>
					<p class="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-white">Self Ship</p>
					<h2 class="text-4xl font-bold leading-tight text-white">Welcome Back</h2>
					<p class="mt-4 text-white">
						Sign in to manage shipments, track updates, and keep your deliveries running smoothly.
					</p>
				</div>
				<div class="space-y-2 text-sm text-white">
					<p>Secure access to your account</p>
					<p>Real-time shipment visibility</p>
				</div>
			</div>

			<div class="px-6 py-10 sm:px-10 lg:px-14">
				<div class="mx-auto w-full max-w-md">
					<router-link to="/" class="mb-8 inline-flex xl:hidden">
						<img src="../assets/images/logo-nav.png" alt="navbar" class="h-10 object-contain" />
					</router-link>

					<h1 class="text-3xl font-bold text-slate-900">Sign In</h1>
					<p class="mt-2 text-sm text-slate-500">Use your account credentials to continue.</p>

					<form class="mt-8 space-y-5" @submit.prevent="handleSubmit()">
						<DangerAlert :message="errors.message" />

						<div class="space-y-2">
							<label for="email" class="text-sm font-semibold text-slate-700">Email</label>
							<input
								id="email"
								v-model="email"
								type="email"
								placeholder="name@example.com"
								class="h-12 w-full rounded-xl border border-slate-300 px-4 text-slate-900 outline-none transition focus:border-slate-900 focus:ring-2 focus:ring-slate-200"
							/>
							<span class="text-sm font-medium text-slate-700">{{ errors?.errors?.email }}</span>
						</div>

						<div class="space-y-2">
							<label for="password" class="text-sm font-semibold text-slate-700">Password</label>
							<div class="relative">
								<input
									id="password"
									v-model="password"
									:type="showPassword ? 'text' : 'password'"
									placeholder="Enter your password"
									class="h-12 w-full rounded-xl border border-slate-300 px-4 pr-11 text-slate-900 outline-none transition focus:border-slate-900 focus:ring-2 focus:ring-slate-200"
								/>
								<img
									@click="toggleShowPassword"
									class="absolute right-3 top-3 cursor-pointer opacity-70 hover:opacity-100"
									src="../assets/icons/icon-eye-open.svg"
									alt="pass-eye"
								/>
							</div>
							<span class="text-sm font-medium text-slate-700">{{ errors?.errors?.password }}</span>
						</div>

						<div class="flex items-center justify-between text-sm">
							<label for="stay-sign-in" class="inline-flex items-center gap-2 text-slate-600">
								<input id="stay-sign-in" type="checkbox" class="h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-slate-300" />
								<span>Stay signed-in</span>
							</label>
							<span @click="$router.push({ name: 'forgot-password' })" class="cursor-pointer font-semibold text-slate-700 hover:text-slate-900">
								Forgot password?
							</span>
						</div>

						<button
							type="submit"
							:disabled="loading"
							class="h-12 w-full rounded-xl border border-slate-900 text-base font-semibold text-slate-900 shadow-sm transition hover:shadow-md disabled:cursor-not-allowed disabled:border-slate-300 disabled:text-slate-400"
						>
							{{ loading ? 'Loading ...' : 'Login' }}
						</button>
					</form>

					<p class="mt-6 text-center text-sm text-slate-500">
						Don't have an account?
						<span @click="goToSignup" class="cursor-pointer font-semibold text-slate-700 hover:text-slate-900">Register</span>
					</p>
				</div>
			</div>
		</div>
		<ShippingExpertsSection />
	</section>
</template>

<script>
import DangerAlert from './Global/Alerts/DangerAlert.vue';
import ShippingExpertsSection from './ShippingExpertsSection.vue';
export default {
	name: "LoginComponent",
	data() {
		return {
			email: "",
			password: "",
			errors: [],
			loading: false,
			showPassword: false,
		};
	},
	components: { DangerAlert, ShippingExpertsSection },
	methods: {
		goToSignup() {
			this.$router.push({ name: 'signup' });
		},
		toggleShowPassword() {
			this.showPassword = !this.showPassword;
		},
		handleSubmit() {
			this.loading = true;
			this.errors = [];

			const data = {
				email: this.email,
				password: this.password,
			};

			this.$axios
				.post("login", data)
				.then((response) => {
					localStorage.setItem("token", response.data.data.token);
					localStorage.setItem("name", response.data.data.name);
					localStorage.setItem("email", response.data.data.email);
					window.dispatchEvent(new Event('auth-state-changed'));
					this.$router.push({ name: "account.dashboard" });
				})
				.catch((error) => {
					this.errors = error.response.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
};
</script>

